export const cx = (...classes: string[]) => {
  return classes.join(" ").trim();
};
